import React from 'react';

interface FallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

/**
 * Composant d'affichage pour les erreurs capturées par ErrorBoundary.
 *
 * @param {Error} error L'erreur capturée.
 * @param {() => void} resetErrorBoundary Fonction pour réinitialiser l'état de l'erreur et tenter de rendre à nouveau le contenu.
 * @returns {JSX.Element} Un composant affichant les détails de l'erreur et un bouton pour réessayer.
 */
export const Fallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div
      role="alert"
      className="p-4 bg-red-100 text-red-800 rounded-lg shadow-md max-w-lg mx-auto my-10"
    >
              <h2 className="text-xl font-bold mb-3 text-red-900">Oops! An error occurred.</h2>
      <p className="text-sm mb-1">Nous avons rencontré un problème inattendu :</p>
      <pre className="whitespace-pre-wrap p-2 bg-red-50 border border-red-200 rounded text-sm text-red-700 mb-4">
        {error.message}
      </pre>
      <p className="text-sm mb-3">
        Vous pouvez essayer de rafraîchir la page ou cliquer sur le bouton ci-dessous.
      </p>
      <button
        onClick={resetErrorBoundary}
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-colors duration-150"
      >
        Réessayer
      </button>
    </div>
  );
};

